import { Search } from 'lucide-react'
import { BasicTable } from '../../../../../components/BasicTable'
import { Input } from '../../../../../components/ui/input'
import { Spinner } from '../../../../../components/ui/spinner'
import { SellerTransactionFilter } from '../SellerTransactionFilter'
import { useSellerTransactionTableController } from './useSellerTransactionTableController'
import { EmptyTransactionsTable } from '../../../../../components/EmptyTransactionsTable'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/view/components/ui/sheet'
import { ModalEditTransaction } from '@/view/pages/Dashboard/components/TransactionTable/components/TransactionDetails/components/EditTransactionModal'
import TransactionDetails from '@/view/pages/Dashboard/components/TransactionTable/components/TransactionDetails'
import { SupportRequestButton } from '@/view/components/SupportRequestButton'

export const SellerTransactionTable = () => {
  const {
    handleNextPage,
    handlePreviousPage,
    handleSearchInputChange,
    isFetching,
    isLoading,
    table,
    getPageCount,
    getPageIndex,
    handleRowClick,
    handleSheetState,
    setSheetOpen,
    sheetOpen,
    selectedItem,
  } = useSellerTransactionTableController()

  return (
    <div className="w-full">
      {table ? (
        <>
          <h2 className="text-xl font-semibold">Listagem de transações</h2>
          <div className="my-5 flex items-center justify-between">
            <div className="relative flex items-center">
              <Search size={20} className="z-2 absolute left-4 top-3" />
              <Input
                className="ml-1 w-52 rounded-3xl pl-10 md:w-72"
                placeholder="Pesquisar transação"
                onChange={handleSearchInputChange}
              />
            </div>
            <div>
              <SellerTransactionFilter />
            </div>
          </div>
        </>
      ) : null}

      <Sheet open={sheetOpen} onOpenChange={setSheetOpen}>
        <SheetContent className="w-[340px] overflow-y-auto rounded-2xl bg-[#F4F5F7] p-2 xs:mr-5 xs:mt-5 xs:h-[95%] xs:w-96 xs:p-5">
          <div className="min-h-[800px]">
            <SheetHeader>
              <SheetTitle className="text-xl font-semibold">
                <div className="flex items-center justify-between">
                  <h2>Detalhes da transação</h2>

                  {selectedItem && (
                    <div className="flex items-center gap-2">
                      <SupportRequestButton
                        context={{ transactionId: selectedItem._id }}
                        title="Abrir chamado sobre esta transação"
                      />
                      <ModalEditTransaction selectedTransaction={selectedItem} />
                    </div>
                  )}
                </div>
                <div className="my-5 w-full border-b-[1px] border-gray01" />
              </SheetTitle>
            </SheetHeader>
            {selectedItem && <TransactionDetails isClient />}
          </div>
        </SheetContent>
      </Sheet>

      {(isFetching || isLoading) && (
        <div className="flex h-screen items-center justify-center">
          <Spinner />
        </div>
      )}

      {!isFetching && (
        <div className="w-full">
          {getPageCount() > 0 ? (
            <div>
              <BasicTable
                getPageCount={getPageCount}
                getPageIndex={getPageIndex}
                handleNextPage={handleNextPage}
                handlePreviousPage={handlePreviousPage}
                table={table}
                handleRowClick={handleRowClick}
                handleSheetState={handleSheetState}
                type="only header"
              />
            </div>
          ) : (
            <EmptyTransactionsTable />
          )}
        </div>
      )}
    </div>
  )
}
